// extracted by mini-css-extract-plugin
module.exports = {"product-card":"simpleheader_product-card__2ha1F","main-header":"simpleheader_main-header__0Dw6Y","container__logo":"simpleheader_container__logo__EyLGz"};